import styled from '@emotion/styled';
import { css } from '@emotion/react';
import tokens from '@vaa-component-lib/shared.design-tokens/json/variables.json';

import { BreakPointToken } from '../../hooks/useMediaQuery';
import { NoGapSupport } from '../../lib/utils/mixins';

const {
	spacing: {
		size_4px: { height: size_4 },
		size_8px: { height: size_8 },
		size_16px: { height: size_16 },
		size_96px: { height: size_96 }
	},
	color: colours
} = tokens;

interface DiscountButtonProps {
	open?: boolean;
}

export const DiscountCodeWrapper = styled.section`
	text-align: right;

	@media (min-width: ${BreakPointToken.MdMin}px) {
		position: relative;
	}
`;

export const DiscountCodeContainer = styled.div`
	display: flex;
	padding: 0 ${size_16}px ${size_16}px;
	align-items: baseline;
	gap: ${size_8}px;

	@media (min-width: ${BreakPointToken.MdMin}px) {
		padding: 0 ${size_16}px;
		min-width: ${size_96 * 3}px;
		box-sizing: content-box;
	}

	.text-field-component {
		flex: 1;
	}

	button {
		position: relative;
		top: -1px;

		${NoGapSupport(
			() => css`
				margin: 0 0 0 ${size_8}px;
			`
		)}
	}

	span[class*='input-feedback-helper'] {
		&:first-of-type {
			margin-bottom: ${size_4}px;
		}
	}
`;

export const DiscountButton = styled.button<DiscountButtonProps>`
	display: inline;
	outline: none;
	border: none;
	padding: 0;
	background: transparent;
	text-decoration: underline;
	color: ${({ open }) =>
		open ? `${colours.light.text_tertiary}` : `${colours.light.text_primary}`};
	cursor: pointer;
	transition: color 0.3s ease-in-out;

	&:hover {
		color: ${colours.light.text_tertiary};
	}

	&:focus {
		outline: 2px solid ${colours.light.blue_40};
		border-radius: ${size_4}px;
	}

	@media (max-width: ${BreakPointToken.SmMax}px) {
		.icon-component {
			display: none;
		}
	}
`;

export const DiscountButtonText = styled.span`
	@media (min-width: ${BreakPointToken.MdMin}px) {
		margin-inline-end: ${size_8}px;
	}
`;
